import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import {
  SaleConsignorModel,
  SaleConsignorTableFields,
} from 'src/app/models/sales/sale-consignor.model';
import { MatDataSource } from '../../shared-new/util/mat-datasource';

export class SaleConsignorListDataSource extends MatDataSource<SaleConsignorModel> {
 
  public constructor(
    data: SaleConsignorModel[],
    sort: MatSort,
    disableInfiniteScroll: boolean = false,
    scrollLevel: number = 20
  ) {
    super(data, sort, disableInfiniteScroll, scrollLevel);
    this.setFilterPredicate();
  }

  clearFilter(): void {
    this.filter = '';  // Clear the filter value
    this.filteredData = [...this.data];  // Reset the filtered data to the original data
    this._updateChangeSubscription();  // Trigger data refresh
  }

  setFilterPredicate(): void {
    this.filterPredicate = (sale: SaleConsignorModel, filterValue: string) => {
      return 'businessName,consignorContact,horsesInSale'.split(',').some((key) => {
        return (
          sale[key as keyof SaleConsignorModel] &&
          new RegExp(filterValue.trim().toLowerCase(), 'gi').test(
            sale[key as keyof SaleConsignorModel]
          )
        );
      });
    };
  }
}
